import React, { useState } from 'react';
import { PageLightbox } from './PageLightbox';
import { LookInsideDesktopCarousel } from './LookInsideDesktopCarousel';
import { LookInsideMobileCarousel } from './LookInsideMobileCarousel';
import { volumeOnePages } from '../data/volumeOnePages';
export function LookInside() {
  const [lightboxIndex, setLightboxIndex] = useState<number | null>(null);
  return <section aria-labelledby="look-inside-heading" className="w-full overflow-hidden bg-[#FAF7F2] text-[#22303C]" data-id="element-137" data-mp="1rx7ovsqvcatw">
      <div className="max-w-6xl mx-auto px-5 py-16 sm:py-20" data-id="element-138" data-mp="1wozh07poaom5">
        <div className="mx-auto max-w-2xl text-center" data-id="element-139" data-mp="1hz1oxgomhero">
          <h2 id="look-inside-heading" className="font-display text-3xl font-extrabold text-[#22303C] sm:text-5xl" data-id="element-140" data-mp="1i0mhj0rdmnmw">
            Look inside Volume 1
          </h2>
          <p className="mt-4 font-sans text-base text-[#22303C]/80 sm:text-lg" data-id="element-141" data-mp="18yvek3o80uwq">
            Real pages from the pack. Every theme comes with a story, a sound
            bank, a target grid and two ready-to-run sessions.
          </p>
        </div>

        <div className="mt-10 sm:mt-12" data-id="element-142" data-mp="61cn18f7imjr">
          <LookInsideMobileCarousel pages={volumeOnePages} onOpen={setLightboxIndex} data-id="element-143" data-mp="60b0o7sqqdmq" />
          <LookInsideDesktopCarousel pages={volumeOnePages} onOpen={setLightboxIndex} data-id="element-144" data-mp="k02iykqaig6j" />
        </div>

        <div className="mt-8 flex flex-col items-center text-center" data-id="element-145" data-mp="3nhayuz1gj5ym">
          <p className="text-sm text-[#8A949C]" data-id="element-146" data-mp="3nfhu5paemvt9">
            Pages shown from Volume 1 of 6. Digital PDF — print what you need.
          </p>
          <a href="#pricing" className="mt-5 inline-flex min-h-[56px] w-full max-w-sm items-center justify-center whitespace-nowrap rounded-full bg-[#E8704F] px-8 text-[19px] font-bold text-white shadow-card transition-[background-color,transform] duration-150 ease-out hover:bg-[#DD6443] active:scale-[0.98] focus:outline-none focus-visible:ring-4 focus-visible:ring-[#4C5FD5]/40 sm:w-auto" data-id="element-147" data-mp="12hrd5w553i8">
            Get all 6 volumes
          </a>
        </div>
      </div>

      <PageLightbox pages={volumeOnePages} index={lightboxIndex} onClose={() => setLightboxIndex(null)} onChange={setLightboxIndex} data-id="element-148" data-mp="18nepvuk7hsz4" />
    </section>;
}